// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__RBtNK","btn_secondary":"Button_btn_secondary__1cB3o"};